import { getInitials } from '@/utils/utility';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { Button, buttonVariants } from '@/components/Button';
import { FiUserX } from 'react-icons/fi';
import { RoleTag, ROLE_AVATAR_STYLE_MAP } from './RoleTag.component';
import styles from '../EmployeeList.module.scss';

// Same plain single-line text cell EmployeeList's own columns use, so
// Department/Email match its typography exactly.
function PlainCell({ children }) {
  return (
    <Text variant={textVariantsEnum.Text_sm} fontWeight={fontWeightEnum.Normal}>
      {children}
    </Text>
  );
}

export const clientsTabConfig = ({ teamLabel, onRevoke, revoking }) => {
  return [
    {
      id: 'name',
      name: 'Client',
      sortable: false,
      style: { width: '30%' },
      cellRenderer: (row) => (
        <div className={styles.employeeCell}>
          <span
            className={styles.employeeAvatar}
            style={ROLE_AVATAR_STYLE_MAP.Client}
          >
            {getInitials(row.name || '')}
          </span>
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {row.name || '—'}
          </Text>
        </div>
      ),
    },
    {
      id: 'role',
      name: 'Role',
      style: { width: '13%' },
      cellRenderer: () => <RoleTag role="Client" />,
    },
    {
      id: 'department',
      name: 'Department',
      style: { width: '15%' },
      cellRenderer: () => <PlainCell>{teamLabel || '—'}</PlainCell>,
    },
    {
      id: 'email',
      name: 'Email',
      style: { width: '25%' },
      cellRenderer: (row) => <PlainCell>{row.email}</PlainCell>,
    },
    {
      id: 'grantedAt',
      name: 'Access granted',
      style: { width: '17%' },
      cellRenderer: (row) => (
        <PlainCell>
          {row?.grantedAt?.toDate
            ? row.grantedAt.toDate().toLocaleDateString()
            : '—'}
        </PlainCell>
      ),
    },
    {
      id: 'actions',
      name: 'Actions',
      style: { width: '7%' },
      cellRenderer: (row) => (
        <Button
          icon={<FiUserX size={14} />}
          variant={buttonVariants.outline}
          ariaLabel="Revoke access"
          disabled={revoking}
          onClick={() => onRevoke(row)}
        />
      ),
    },
  ];
};
